import ProfileWidget from '@/widgets/profile';

export default function ProfilePage() {
    return <ProfileWidget />;
}
